import {Event, GamePreferences, GameProposition} from "../api.types"

export interface GameEntryView {
    id : string
    name : string
    thumbnail : string
    points : number[]
    propositions : boolean[]
    propositionCount : number
    pointSum : number
    pointExtra : number
    notes : string[]
    dropOff?: boolean
}

export function toGameEntryView(event : Event) : GameEntryView[] {
    const startPoints = 4;

    const preferences : GamePreferences = event.preferences || {
        dropOfGameIds: [],
        userPreferences: []
    }
    const propositions : GameProposition[] = event.propositions || [];

    const games : GameEntryView[] = (propositions || []).map((e : GameProposition) => {
        return {
            id: e.gameId,
            name: e.name,
            thumbnail: e.thumbnail,
            points: new Array<number>(preferences.userPreferences.length),
            propositions: new Array<boolean>(preferences.userPreferences.length),
            propositionCount: e.propositionCount,
            pointSum: 0,
            pointExtra: (e.propositionCount - 1) * 3,
            notes: e.notes,
            dropOff: preferences
                .dropOfGameIds
                .indexOf(e.gameId) !== -1
        }
    })

    for (let i = 0; i < preferences.userPreferences.length; i++) {
        const pref = preferences.userPreferences[i]
        for (let idx = 0; idx < pref.ids.length; idx++) {
            const g = games.find(e => e.id === pref.ids[idx])
            if (g) {
                g.points[i] = startPoints - idx
                g.pointSum += startPoints - idx
            }
        }
        if (pref.proposedIds) {
            for (const propId of pref.proposedIds) {
                const g = games.find(e => e.id === propId)
                if (g) {
                    g.propositions[i] = true
                }
            }
        }
    }
    games.sort((a, b) => (b.pointSum + b.pointExtra) - (a.pointSum + a.pointExtra) || a.name.localeCompare(b.name))

    return games;
}
